/**
 * dropdown
 */

export default function dropdown() {

  const dropdowns = Array.from(document.querySelectorAll('[data-js="dropdown-trigger"]'));

  // When dropdowns exists
  if (dropdowns.length > 0) {

    var trigger = function () {
      dropdowns.forEach(trigger => {
        trigger.addEventListener('click', function() {
          var id = trigger.dataset.menu
          document.getElementById(id).classList.toggle('is-open')
        }, false);
      });
    };
    trigger();
  }
}